import { render, staticRenderFns } from "./ReturnDetail.vue?vue&type=template&id=39af7f9b&"
import script from "./ReturnDetail.vue?vue&type=script&lang=js&"
export * from "./ReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReturnDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports